import type { Except } from "type-fest";
import { z } from "zod";
import { nowIsoAndUnix } from "../../date-time/iso-and-unix";
import { imageContentTypes } from "../content-types";
import { storageItemBaseZodSchema } from "../storage-item-base";
import type {
    StorageItemImageId} from "./storage-item-image-id";
import {
    storageItemImageIdFactory,
    storageItemImageIdZodSchema,
} from "./storage-item-image-id";

const storageItemImageZodSchema = storageItemBaseZodSchema.merge(
    z.object({
        _id: storageItemImageIdZodSchema,
        type: z.literal("IMAGE"),
        contentType: z.enum(imageContentTypes),
        blurhash: z.string().optional(),
    }),
);
type StorageItemImage = z.infer<typeof storageItemImageZodSchema>;

type StorageItemImageFactoryParams = Except<
    StorageItemImage,
    "_id" | "type" | "_createdAt" | "_type"
> & {
    _id?: StorageItemImageId;
};

const storageItemImageFactory = (
    params: StorageItemImageFactoryParams,
): StorageItemImage => {
    return {
        _id: params._id ?? storageItemImageIdFactory(),
        _type: "STORAGE_ITEM",
        type: "IMAGE",
        _createdAt: nowIsoAndUnix(),
        ...params,
    };
};

const isStorageItemImage = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    storageItem: any,
): storageItem is StorageItemImage => {
    if (typeof storageItem === "undefined") return false;
    if (storageItem === null) return false;
    if (storageItem._type !== "STORAGE_ITEM") return false;
    return storageItem.type === "IMAGE";
};

export {
    isStorageItemImage,
    storageItemImageFactory,
    storageItemImageZodSchema,
};
export type { StorageItemImage };
